var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrenWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.421,
    height: 180.636,
    viewBox: "0 0 222.421 180.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5f5f5;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tren_White",
    transform: "translate(920.105 -8544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    className: "cls-1",
    d: "M249.692,425.5H241a3.5,3.5,0,0,1,0-7h8.692a3.5,3.5,0,1,1,0,7Z",
    transform: "translate(-1101.115 8282.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    className: "cls-1",
    d: "M330.741,386.281H320.9a3.5,3.5,0,1,1,0-7h9.838a5.727,5.727,0,0,0,4.829-2.6,5.628,5.628,0,0,0,.483-5.431l-5.613-12.916a15.192,15.192,0,0,0-13.941-9.114l-182.805,0a5.768,5.768,0,0,0-5.732,5.732v18.588a5.768,5.768,0,0,0,5.732,5.732h14.123a3.5,3.5,0,0,1,0,7H133.694a12.672,12.672,0,0,1-12.674-12.674V355.019a12.672,12.672,0,0,1,12.674-12.674H316.441a22.2,22.2,0,0,1,20.339,13.278l5.613,12.916a12.687,12.687,0,0,1-11.649,17.741Z",
    transform: "translate(-1041.125 8321.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    className: "cls-1",
    d: "M392.189,425.5H327.372a3.5,3.5,0,0,1,0-7H392.13a3.5,3.5,0,0,1,3.5,3.5,3.452,3.452,0,0,1-3.44,3.5Z",
    transform: "translate(-1145.599 8282.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    className: "cls-1",
    d: "M477.617,424.473a20.1,20.1,0,1,1,20.1-20.1A20.13,20.13,0,0,1,477.617,424.473Zm0-33.194a13.157,13.157,0,1,0,13.157,13.157A13.187,13.187,0,0,0,477.617,391.28Z",
    transform: "translate(-1214.431 8300.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    className: "cls-1",
    d: "M489.41,425.29A8.993,8.993,0,1,1,498.4,416.3,9.015,9.015,0,0,1,489.41,425.29Zm0-11.1a2.052,2.052,0,1,0,2.052,2.052A2.074,2.074,0,0,0,489.41,414.185Z",
    transform: "translate(-1226.224 8288.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    className: "cls-1",
    d: "M189.157,424.473a20.1,20.1,0,1,1,20.1-20.1A20.13,20.13,0,0,1,189.157,424.473Zm0-33.194a13.157,13.157,0,1,0,13.157,13.157A13.187,13.187,0,0,0,189.157,391.28Z",
    transform: "translate(-1065.866 8300.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    className: "cls-1",
    d: "M200.95,425.29a8.993,8.993,0,1,1,8.993-8.993A9.015,9.015,0,0,1,200.95,425.29Zm0-11.1A2.052,2.052,0,1,0,203,416.236,2.035,2.035,0,0,0,200.95,414.185Z",
    transform: "translate(-1077.659 8288.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    className: "cls-1",
    d: "M275.517,424.473a20.1,20.1,0,1,1,20.1-20.1A20.13,20.13,0,0,1,275.517,424.473Zm0-33.194a13.157,13.157,0,1,0,13.157,13.157A13.187,13.187,0,0,0,275.517,391.28Z",
    transform: "translate(-1110.344 8300.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    className: "cls-1",
    d: "M287.31,425.29A8.993,8.993,0,1,1,296.3,416.3,9.015,9.015,0,0,1,287.31,425.29Zm0-11.1a2.052,2.052,0,1,0,2.052,2.052A2.074,2.074,0,0,0,287.31,414.185Z",
    transform: "translate(-1122.137 8288.303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    className: "cls-1",
    d: "M429.833,289.178a3.5,3.5,0,0,1-3.5-3.5V250.672a17.927,17.927,0,0,0-17.925-17.925l-71.335,0a3.5,3.5,0,1,1,0-7h71.4a24.906,24.906,0,0,1,24.865,24.865v35.005a3.555,3.555,0,0,1-3.5,3.562Z",
    transform: "translate(-1150.595 8381.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    className: "cls-1",
    d: "M247.361,241.427H163.592a3.5,3.5,0,0,1-3.5-3.5V136.533a3.5,3.5,0,0,1,3.5-3.5h83.769a3.5,3.5,0,0,1,3.5,3.5V237.985a3.452,3.452,0,0,1-3.5,3.44Zm-80.268-6.941h76.829l0-94.453H167.1Z",
    transform: "translate(-1061.248 8429.561)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    className: "cls-1",
    d: "M248.73,242.841H209.019a3.5,3.5,0,0,1-3.5-3.5v-57.4a3.5,3.5,0,0,1,3.5-3.5H248.73a3.5,3.5,0,0,1,3.5,3.5v57.4A3.5,3.5,0,0,1,248.73,242.841Zm-36.271-7h32.772V185.447H212.46Z",
    transform: "translate(-1084.644 8406.173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    className: "cls-1",
    d: "M237.011,120.284H137.432a12.8,12.8,0,1,1,0-25.59l99.521,0a12.794,12.794,0,0,1,.061,25.588Zm-99.584-18.649a5.854,5.854,0,1,0,0,11.707l99.521,0a5.854,5.854,0,0,0,0-11.707Z",
    transform: "translate(-1042.988 8449.306)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    className: "cls-1",
    d: "M445.092,210.689a3.5,3.5,0,0,1-3.5-3.5v-21a3.5,3.5,0,0,1,7,0v21a3.5,3.5,0,0,1-3.5,3.5Z",
    transform: "translate(-1206.228 8403.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    className: "cls-1",
    d: "M472.592,210.689a3.5,3.5,0,0,1-3.5-3.5v-21a3.5,3.5,0,0,1,7,0v21a3.5,3.5,0,0,1-3.5,3.5Z",
    transform: "translate(-1220.391 8403.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    className: "cls-1",
    d: "M451.205,175.2H434.487a10.321,10.321,0,1,1,0-20.641h16.718a10.321,10.321,0,1,1,0,20.641Zm-16.779-13.64a3.38,3.38,0,1,0,0,6.759h16.718a3.38,3.38,0,1,0,0-6.759Z",
    transform: "translate(-1197.253 8418.475)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    className: "cls-1",
    d: "M431.3,275.054H395.81a3.5,3.5,0,1,1,0-7H431.3a3.5,3.5,0,0,1,0,7Z",
    transform: "translate(-1180.846 8360.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    className: "cls-1",
    d: "M431.176,307.034H395.69a3.5,3.5,0,0,1,0-7h35.486a3.5,3.5,0,1,1,0,7Z",
    transform: "translate(-1180.785 8343.551)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    className: "cls-1",
    d: "M532.647,290.059h-5.069a3.5,3.5,0,0,1,0-7h5.069a3.657,3.657,0,0,0,3.681-3.681V269.9a3.657,3.657,0,0,0-3.681-3.681h-5.674a3.5,3.5,0,0,1,0-7h5.674a10.638,10.638,0,0,1,10.622,10.622v9.536a10.651,10.651,0,0,1-10.622,10.681Z",
    transform: "translate(-1248.399 8364.57)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrenWhite);
export default __webpack_public_path__ + "static/media/Tren_White.941f35a90b25cf61e336e00f5ad7d2fa.svg";
export { ForwardRef as ReactComponent };